import React from "react";
import { Notification } from "../../components/alerting-visitors/notification";
import SideBar from "../../components/sidebar/Sidebar";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import "../../css/myestare.css";

function TrusteeBanks() {
  

  return (
    <TrusteeBase>
      <div className="mt-5"></div>
      <SideBar>
        <div style={{ marginTop: "30px" }}>
          <Notification />
        </div>

        
      </SideBar>
    </TrusteeBase>
  );
}

export default TrusteeBanks;
